import { render, staticRenderFns } from "./AdminEventSettings.vue?vue&type=template&id=66884e7e&scoped=true&"
import script from "./AdminEventSettings.vue?vue&type=script&lang=js&"
export * from "./AdminEventSettings.vue?vue&type=script&lang=js&"
import style0 from "./AdminEventSettings.vue?vue&type=style&index=0&id=66884e7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66884e7e",
  null
  
)

export default component.exports